import { restRequest } from "../../redux/utilities";
export var SIGNIN = restRequest("SIGNIN");
export var AGREE_TO_EULA = restRequest("AGREE_TO_EULA");
export var GET_APP_URL = restRequest("GET_APP_URL");
export var FORGOT_PWD = restRequest("FORGOT_PWD");